import React from "react";
import "./Footer.css";
import logo from '../assets/logo2.png'

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-logo">
              <img src={logo}/>
            </div>
            <p className="footer-desc">
              Transforming African economies through distinctive financial
              solutions since 2007.
            </p>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#partners">Partners</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-contact">
              <li>Delta Tower, 13th Floor</li>
              <li>Westlands, Nairobi, Kenya</li>
              <li>+254 757 926 268</li> 
              <li>info@benchmarksolutions.com</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Benchmark Solutions Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
